import {
  Box,
  Card,
  CardBody,
  Flex,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  VStack,
  useColorModeValue
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { StatBadge } from "./StatBadge";

export const IncludedServicesPageHeader = ({
  searchTerm,
  stats,
  texts,
  onSearchChange
}) => {
  return (
    <Card
      mb={0.5}
      borderRadius="2xl"
      shadow="2xl"
      bg={useColorModeValue("white", "gray.800")}
      border="1px"
      borderColor={useColorModeValue("gray.200", "gray.700")}
      overflow="hidden"
    >
      <CardBody p={0}>
        <VStack spacing={1} align="stretch">
          <Flex
            direction={{ base: "column", lg: "row" }}
            justify="space-between"
            align={{ base: "start", lg: "center" }}
            gap={1}
          >
            <Box flex={1}>
              <Heading
                as="h1"
                size="2xl"
                fontWeight="bold"
                color={useColorModeValue("gray.800", "white")}
                mb={3}
              >
                📦 {texts?.sidebar?.includedServices}
              </Heading>
              <Text fontSize="lg" color="gray.600" maxW="2xl">
                {texts?.includedServicesPage?.description}
              </Text>
            </Box>

            <HStack spacing={4} flexWrap="wrap" justify={{ base: "start", lg: "end" }}>
              <StatBadge label={texts?.contracts} value={stats.totalContracts} color="purple" size="lg" />
              <StatBadge label={texts?.mainPackages} value={stats.contractsWithPackages} color="green" size="lg" />
              <StatBadge label={texts?.active} value={stats.activeContracts} color="blue" size="lg" />
              <StatBadge label={texts?.expired} value={stats.expiredContracts} color="red" size="lg" />
            </HStack>
          </Flex>

          <Card bg={useColorModeValue("gray.50", "gray.700")} borderRadius="xl" p={4}>
            <Flex
              direction={{ base: "column", md: "row" }}
              gap={4}
              align={{ base: "stretch", md: "center" }}
            >
              <InputGroup flex={1}>
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.500" />
                </InputLeftElement>
                <Input
                  placeholder={texts?.searchPlaceholder}
                  value={searchTerm}
                  onChange={(e) => onSearchChange(e.target.value)}
                  size="lg"
                  borderRadius="lg"
                  _focus={{
                    borderColor: "purple.400",
                    boxShadow: "0 0 0 1px var(--chakra-colors-purple-400)"
                  }}
                />
              </InputGroup>
            </Flex>
          </Card>
        </VStack>
      </CardBody>
    </Card>
  );
};
